import { useState, useEffect } from "react";
import { getEmptyDataStructure, validateField } from "./validation";

const API_URL = process.env.REACT_APP_API_URL || 'https://apiprov.conduto.com.ec';

export const useProviderForm = (formData, setFormData, isJuridica, idFormulario) => {
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [showCustomFormaPago, setShowCustomFormaPago] = useState(false);
  const [razonSocialOriginal, setRazonSocialOriginal] = useState("");

  const actualizarRazonSocialEnCarpeta = async (nuevaRazonSocial) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/api/documentos/proveedores/actualizar-razon-social/${idFormulario}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ razon_social: nuevaRazonSocial })
      });
      return response.ok;
    } catch (error) {
      console.error('Error actualizando razón social en carpeta:', error);
      return false;
    }
  };

  useEffect(() => {
    const load = async () => {
      if (!idFormulario) {
        setFormData((prev) => ({ ...prev, providerInfo: getEmptyDataStructure() }));
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          `${API_URL}/api/providers/proveedor-datos/${idFormulario}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            credentials: "include",
          }
        );

        const payload = { ...getEmptyDataStructure() };

        if (res.ok) {
          const data = await res.json();
          if (data && typeof data === 'object') {
            Object.keys(payload).forEach(key => {
              if (data[key] !== null && data[key] !== undefined) {
                payload[key] = data[key];
              }
            });
            setRazonSocialOriginal(data.razon_social || "");
          }
        }

        setFormData((prev) => ({ ...prev, providerInfo: payload }));
      } catch (e) {
        console.error("Error de conexión:", e);
        setFormData((prev) => ({ ...prev, providerInfo: getEmptyDataStructure() }));
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, [idFormulario, setFormData]);

  const handleChange = (field) => (e) => {
    let val = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (field === "contribuyente_especial") {
      if (e.target.type === "radio") {
        val = e.target.value === "SI";
      }
    }

    const valorAnterior = formData.providerInfo?.[field];

    if (field === "forma_pago") {
      const isOtro = val === "Otro";
      setShowCustomFormaPago(isOtro);

      if (!isOtro) {
        setFormData((prev) => ({
          ...prev,
          providerInfo: {
            ...prev.providerInfo,
            [field]: val,
            forma_pago_otro: "",
          },
        }));
        if (touched.forma_pago_otro) {
          const error = validateField("forma_pago_otro", "", isJuridica);
          setErrors(prev => ({ ...prev, forma_pago_otro: error }));
        }
      } else {
        setFormData((prev) => ({
          ...prev,
          providerInfo: { ...prev.providerInfo, [field]: val },
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        providerInfo: { ...prev.providerInfo, [field]: val },
      }));
    }

    if (field === "razon_social" && idFormulario && razonSocialOriginal &&
      valorAnterior && val && valorAnterior !== val) {
      setTimeout(async () => {
        await actualizarRazonSocialEnCarpeta(val);
      }, 500);
    }

    if (touched[field]) {
      const error = validateField(field, val, isJuridica);
      setErrors(prev => ({ ...prev, [field]: error }));
    }
  };

  const handleBlur = (field) => (e) => {
    setTouched(prev => ({ ...prev, [field]: true }));
    const value = formData.providerInfo?.[field] || "";
    const error = validateField(field, value, isJuridica);
    setErrors(prev => ({ ...prev, [field]: error }));
  };

  const handleFocus = (field) => (e) => {
    if (!touched[field]) {
      setTouched(prev => ({ ...prev, [field]: true }));
    }
  };

  const validateForm = () => {
    const e = {};
    const data = formData.providerInfo || {};

    Object.keys(data).forEach(field => {
      const error = validateField(field, data[field], isJuridica);
      if (error) {
        e[field] = error;
      }
    });

    setErrors(e);
    setTouched(Object.keys(data).reduce((acc, key) => ({ ...acc, [key]: true }), {}));
    return Object.keys(e).length === 0;
  };

  return {
    errors,
    touched,
    isLoading,
    showCustomFormaPago,
    setShowCustomFormaPago,
    handleChange,
    handleBlur,
    handleFocus,
    validateForm,
    setErrors,
    setTouched
  };
};